<script>
import StackedBarChart from "@/components/charts/StackedBarChart";

const CHART_COLORS = {
  products: "#34c38f",
  accessories: "#2fb182",
  bo: "#f46a6a",
  damaged: "#f1b44c",
};

export default {
  components: { StackedBarChart },
  data() {
    return { chartColors: CHART_COLORS };
  },
  props: {
    nbBO: { type: Number, default: 0 },
    nbDamaged: { type: Number, default: 0 },
    percentCompleted: { type: Number, default: 0 },
    nbProductCompleted: { type: Number, default: 0 },
    nbProduct: { type: Number, default: 0 },
    nbDetachedCompleted: { type: Number, default: 0 },
    nbDetached: { type: Number, default: 0 },
    alertMode: { type: Boolean, default: false },
  },
  computed: {
    segments() {
      return [
        {
          label: this.$t("general.products"),
          value: this.nbProductCompleted,
          color: this.chartColors.products,
        },
        {
          label: this.$t("general.accessories"),
          value: this.nbDetachedCompleted,
          color: this.chartColors.accessories,
        },
        {
          label: this.$t("general.bo"),
          value: this.nbBO,
          color: this.chartColors.bo,
        },
        {
          label: this.$t("general.damaged"),
          value: this.nbDamaged,
          color: this.chartColors.damaged,
        },
      ];
    },
    chartTitle() {
      return this.percentCompleted > 0 ? `${this.percentCompleted}%` : "0%";
    },
  },
};
</script>
<template>
  <div class="card progress-card m-0 h-100">
    <b-form-radio-group
      :checked="alertMode"
      buttons
      class="w-100"
      @input="$emit('update:alertMode', $event)"
    >
      <b-form-radio :value="false" button-variant="outline-success">{{
        $t("general.scanMode")
      }}</b-form-radio>
      <b-form-radio :value="true" button-variant="outline-warning">{{
        $t("general.alertMode")
      }}</b-form-radio>
    </b-form-radio-group>
    <div class="card-body p-0 p-md-2 d-flex flex-column justify-content-center" :class="{ 'alert-mode': alertMode }">
      <div class="d-flex justify-content-center overflow-hidden w-100 px-2">
        <StackedBarChart
          :height="70"
          :segments="segments"
          :max="nbProduct"
          :title="chartTitle"
        ></StackedBarChart>
      </div>
      <div
        class="d-flex flex-row justify-content-around flex-wrap"
        style="row-gap: 0.25rem;"
      >
        <div class="d-flex flex-grow-1 justify-content-around">
          <div
            class="px-1 rounded border d-flex justify-content-center align-items-center"
            :style="{ gap: '0.3rem', borderColor: chartColors.products + ' !important' }"
          >
            <div class="legend-box" :style="{ backgroundColor: chartColors.products }"></div>
            <i
              class="mdi mdi-24px mdi-cube-outline align-middle"
            ></i>
            <span class="d-none d-md-inline">{{
              $t("general.completedproducts")
            }}</span>
            <span>{{ nbProductCompleted }}/{{ nbProduct }}</span>
          </div>
          <div
            class="px-1 rounded border d-flex justify-content-center align-items-center"
            :style="{ gap: '0.3rem', borderColor: chartColors.accessories + ' !important' }"
          >
            <div class="legend-box" :style="{ backgroundColor: chartColors.accessories }"></div>
            <i
              class="mdi mdi-24px mdi-puzzle-outline align-middle"
            ></i>
            <span class="d-none d-md-inline">{{
              $t("general.completedaccessories")
            }}</span>
            <span>{{ nbDetachedCompleted }}/{{ nbDetached }}</span>
          </div>
        </div>
        <div class="d-flex flex-grow-1 justify-content-around">
          <div
            class="px-1 rounded border d-flex justify-content-center align-items-center"
            :style="{ gap: '0.3rem', borderColor: chartColors.bo + ' !important' }"
          >
            <div class="legend-box" :style="{ backgroundColor: chartColors.bo }"></div>
            <span
              class="font-weight-bold font-size-20"
              :style="{ color: chartColors.bo }"
              >{{ $t("general.bo") }}</span
            >
            <span>{{ nbBO }}</span>
          </div>
          <div
            class="px-1 rounded border d-flex justify-content-center align-items-center"
            :style="{ gap: '0.3rem', borderColor: chartColors.damaged + ' !important' }"
          >
            <div class="legend-box" :style="{ backgroundColor: chartColors.damaged }"></div>
            <i
              class="mdi mdi-36px ico-damaged text-warning align-middle"
              :style="{height: '36px', display: 'flex', alignItems: 'center'}"
            ></i>
            <span class="d-none d-md-inline">{{
              $t("general.damaged")
            }}</span>
            <span>{{ nbDamaged }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.legend-box {
  width: 15px;
  height: 10px;
}
/* .card-body {
  border: 5px solid transparent;
}
.alert-mode.card-body {
  border-color: #f1b44c;
} */
</style>
